<template>
    <transition @appear="onAppear" @leave="onLeave" :css="false" appear>
        <div
            class="fixed bottom-0 inset-0 flex items-center justify-center p-6"
            style="z-index: 1000;"
        >
            <div
                class="absolute inset-0 bg-gray-500 opacity-75 modal-backdrop"
                :class="{'cursor-pointer': !disableClose }"
                @click.stop.prevent="!disableClose && $emit('close')"
            ></div>

            <div
                class="bg-white flex flex-col rounded-lg max-h-full shadow-xl transform transition-all w-full sm:max-w-xl sm:w-full modal-content"
            >
                <div class="flex-grow p-6 pb-0 overflow-auto">
                    <slot />
                </div>
                <div class="p-6">
                    <slot name="buttons" />

                    <button
                        v-if="!disableClose"
                        @click.stop.prevent="$emit('close')"
                        type="button"
                        class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-gray-800 text-base leading-6 font-medium text-white shadow-sm hover:bg-gray-700 focus:outline-none focus:border-gray-900 focus:shadow-outline-gray transition ease-in-out duration-150 sm:text-sm sm:leading-5"
                    >Close</button>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    props: ['disableClose'],
    mounted() {
        document.body.classList.add('modal-open');
    },
    methods: {
        onAppear(el, done) {
            const tl = gsap.timeline({
                onComplete: done,
            });

            tl.from(el.querySelector('.modal-backdrop'), {
                opacity: 0,
                duration: 0.25,
            });

            tl.fromTo(
                el.querySelector('.modal-content'),
                {
                    opacity: 0,
                    y: '-=20',
                },
                {
                    opacity: 1,
                    y: 0,
                    duration: 0.25,
                },
            );
        },
        onLeave(el, done) {
            const tl = gsap.timeline({
                onComplete: done,
            });

            tl.to(el.querySelector('.modal-content'), {
                opacity: 0,
                y: '-=20',
                duration: 0.25,
                onComplete: () => {
                    document.body.classList.remove('modal-open');
                },
            });

            tl.to(el.querySelector('.modal-backdrop'), {
                opacity: 0,
                duration: 0.25,
            });
        },
    },
};
</script>
